import React from 'react';
import { BookOpen, Play, Clock, CheckCircle, BarChart3 } from 'lucide-react';

const trainings = [
  { id: 1, name: 'Fine-tune Qwen2.5 Custom', model: 'Qwen2.5:7b', dataset: 'koolaber_conversations', status: 'running', progress: 62, epochs: 3, eta: '14 min' },
  { id: 2, name: 'Voice Clone - New Speaker', model: 'XTTS v2', dataset: 'speaker_samples_v3', status: 'queued', progress: 0, epochs: 10, eta: '~45 min' },
  { id: 3, name: 'Distillation Pipeline - Pi TTS', model: 'Piper', dataset: 'tts_dataset_clean', status: 'completed', progress: 100, epochs: 5, eta: '-' },
];

function TrainingSection() {
  return (
    <div className="p-8 space-y-8">
      <div>
        <h2 className="text-3xl font-bold text-white">Training</h2>
        <p className="text-slate-400 mt-1">Fine-tuning and distillation pipelines</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {trainings.map((t) => (
          <div key={t.id} className="glass-panel p-6">
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                  t.status === 'running' ? 'bg-amber-600/20' :
                  t.status === 'queued' ? 'bg-blue-600/20' : 'bg-emerald-600/20'
                }`}>
                  {t.status === 'running' ? <Play className="w-5 h-5 text-amber-400" /> :
                   t.status === 'queued' ? <Clock className="w-5 h-5 text-blue-400" /> :
                   <CheckCircle className="w-5 h-5 text-emerald-400" />}
                </div>
                <div>
                  <p className="text-sm font-semibold text-white">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.model}</p>
                </div>
              </div>
            </div>
            <div className="space-y-3">
              <div className="flex justify-between text-xs">
                <span className="text-slate-500">Progress</span>
                <span className="text-white">{t.progress}%</span>
              </div>
              <div className="h-2 bg-slate-800 rounded-full overflow-hidden">
                <div className={`h-full rounded-full transition-all ${
                  t.status === 'completed' ? 'bg-emerald-500' :
                  t.status === 'running' ? 'bg-amber-500' : 'bg-blue-500'
                }`} style={{ width: `${t.progress}%` }} />
              </div>
              <div className="flex justify-between text-xs">
                <span className="text-slate-500">{t.dataset} · {t.epochs} epochs</span>
                <span className="text-slate-400">{t.eta}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default TrainingSection;
